<template>
  <Modal
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    max-width="max-w-[520px]"
    @close="emit('update:modelValue', false)"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary text-left">Reverter validação</h2>
    </template>

    <div class="flex flex-col gap-3 text-left">
      <p class="text-sm text-textPrimary">
        Informe o motivo da reversão. O registro retornará para auditoria.
      </p>
      <textarea
        v-model="justification"
        class="w-full border border-neutral30 rounded-lg p-3 text-sm text-textPrimary resize-none focus:outline-none focus:ring-2 focus:ring-primary30"
        rows="4"
        placeholder="Descreva o motivo da reversão..."
        data-testid="ds-attendance-revert-justification-input"
      />
    </div>

    <template #footer>
      <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
        <OutlineButton
          text="Cancelar"
          width="96px"
          height="40px"
          data-testid="ds-attendance-revert-cancel-button"
          @click="emit('update:modelValue', false)"
        />
        <FilledButton
          text="Confirmar reversão"
          class="bg-negative"
          width="180px"
          height="40px"
          data-testid="ds-attendance-revert-confirm-button"
          :disabled="saving || !justification.trim()"
          @click="emit('confirm', justification.trim())"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

const props = defineProps<{
  modelValue: boolean
  saving: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: [justification: string]
}>()

const justification = ref('')

watch(
  () => props.modelValue,
  (open) => {
    if (!open) justification.value = ''
  }
)
</script>
